<script setup lang="ts">
import { computed } from 'vue';
import { i18n } from '@/i18n';

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    ariaLabel?: string;
  }>(),
  {
    disabled: false,
    ariaLabel: undefined,
  }
);

const ariaLabelValue = computed(() => props.ariaLabel ?? i18n.t('ドラッグして並び替え').toString());
</script>

<template>
  <span
    class="drag-handle"
    :class="{ 'drag-handle--disabled': disabled }"
    :aria-disabled="disabled"
    :aria-label="ariaLabelValue"
    :tabindex="disabled ? undefined : 0"
    role="button"
  >
    <span v-for="index in 6" :key="index" class="drag-handle__dot" />
  </span>
</template>

<style lang="scss" scoped>
.drag-handle {
  display: inline-grid;
  grid-template-columns: repeat(2, 4px);
  grid-template-rows: repeat(3, 4px);
  gap: 3px;
  place-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }

  &:focus-visible {
    outline: 2px solid $semanticPrimary;
    outline-offset: 2px;
    border-radius: 4px;
  }

  &--disabled {
    cursor: default;
    opacity: 0.4;
    pointer-events: none;
  }

  &__dot {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: $textSecondary;
  }
}
</style>
